export default "__VITE_ASSET__D06xVKoz__"